import env from '../env';

import { SetCookie, RemoveCookie } from './cookie';

export const isTokenExpired = (token: string): boolean => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replaceAll('-', '+').replaceAll('_', '/');
    const payload = JSON.parse(window.atob(base64));
    
    // Convert exp to milliseconds and compare with Buffer (60s)
    // payload.exp * 1000 is the exact expiry time
    const isExpired = Date.now() >= (payload.exp * 1000) - 60000;
    
    console.log(`[Auth] Token Status - Expiry: ${new Date(payload.exp * 1000).toISOString()}, Now: ${new Date().toISOString()}, Needs Refresh: ${isExpired}`);
    
    return isExpired;
  } catch (error) {
    console.warn('JWT parsing failed in isTokenExpired:', error);
    return true;
  }
};

export const refreshAuthToken = async (refreshToken: string): Promise<string | null> => {
  try {
    const uri = env.APP_API_GRAPHQL_ENDPOINT || env.APP_GRAPHQL_ENDPOINT || '';
    const response = await fetch(uri, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        query: `
          query getAccessToken($refreshToken: String!) {
            getAccessToken(refreshToken: $refreshToken) {
              AccessToken
              RefreshToken
              ExpiresIn
            }
          }
        `,
        variables: { refreshToken },
      }),
    });

    const result = await response.json();
    const tokenData = result.data?.getAccessToken;

    if (tokenData?.AccessToken) {
      const newAccessToken = tokenData.AccessToken;
      const newRefreshToken = tokenData.RefreshToken || refreshToken;

      SetCookie('AccessToken', newAccessToken);
      
      if (tokenData.RefreshToken) {
        SetCookie('RefreshToken', tokenData.RefreshToken);
      }

      // Update compatibility tokens for other parts of the app
      // const authData = {
      //   accessToken: newAccessToken,
      //   refreshToken: newRefreshToken,
      // };

      // localStorage.setItem('jwapp.auth', JSON.stringify(authData));

      SetCookie('InplayerToken', {
        token: newAccessToken,
        refreshToken: newRefreshToken,
      });

      return newAccessToken;
    }
  } catch (error) {
    console.error('Failed to refresh auth token:', error);
  }
  return null;
};

export const clearAuthStorage = () => {
  RemoveCookie('AccessToken');
  RemoveCookie('RefreshToken');
  RemoveCookie('IdToken');
  RemoveCookie('InplayerToken');
  localStorage.clear();
};
